import React from 'react';
import type { Person } from '../data/people';
interface PersonRowProps {
  person: Person;
}
export function PersonRow({
  person
}: PersonRowProps) {
  return <article className="grid gap-6 border-b border-ink-200 py-10 sm:grid-cols-[1fr_1.6fr] sm:gap-12" data-id="element-36" data-mp="36gvmk6zmk3zk">
      <div className="flex items-start gap-4" data-id="element-37" data-mp="2sltm3zdjr6u5">
        {person.photo ? <img src={person.photo} alt={`Portrait of ${person.name}`} width={856} height={1180} loading="lazy" className="h-36 w-28 shrink-0 object-cover object-center grayscale" data-id="element-38" data-mp="2wlc5gqppz9uv" /> : <span aria-hidden="true" className="flex h-36 w-28 shrink-0 items-center justify-center bg-accent-soft font-display text-lg text-accent" data-id="element-39" data-mp="3bh9tflphp7w0">
            {person.initials}
          </span>}
        <div className="pt-1" data-id="element-40" data-mp="720f4oul9q7y">
          <h3 className="font-display text-[22px] leading-tight text-ink-950" data-id="element-41" data-mp="bvczgms8jauw">
            {person.name}
            {person.credential && <span className="text-ink-500" data-id="element-42" data-mp="13o4mz85dsy0z">, {person.credential}</span>}
          </h3>
          <p className="mt-1.5 text-sm text-accent" data-id="element-43" data-mp="yq386zeznkvb">{person.role}</p>
        </div>
      </div>
      <p className="max-w-prose text-[15px] leading-relaxed text-ink-700" data-id="element-44" data-mp="1dezbyka0ibq4">{person.bio}</p>
    </article>;
}